module.exports = __webpack_public_path__ + "img/icon_save_blue.20abe717.png";